import { FC } from 'react';

export const Intro: FC = () => (
  <>
    <div className='overlay'></div>
    <div className='container'>
      <h5>
        <span className='strong nowrap'> Node.js Back-end,</span> Full Stack Node.js React Developer
      </h5>
      <h6>Занимаясь тем, что любишь - принесешь пользу себе и людям, и непременно придешь к успеху</h6>
    </div>
  </>
);
